<template>
    <div class="admin_loader" v-if="isLoader">
        <div class="__visibility_block"></div>
        <div class="__loader_wrap">
            <div class="__loader_image"><span></span></div>
            <div class="__loader_content">Уншиж байна ...</div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    isLoader: Boolean
  }
}
</script>
